// RouteChangeTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../helper/helper";

const normalizePathname = (pathname) => {
  // Define patterns for dynamic segments
  const patterns = [
    { pattern: /\/transaction\/complete\/\d+/, replacement: '/transaction/complete/:id' },
    { pattern: /\/transaction\/confirm\/\d+\/\d+/, replacement: '/transaction/confirm/:id/:amount' },
    { pattern: /\/transaction\/details\/\d+/, replacement: '/transaction/details/:transid' },
    { pattern: /\/transaction\/create\/\d+/, replacement: '/transaction/create/:id' },
    { pattern: /\/transaction\/recipient\/\d+/, replacement: '/transaction/recipient/:id' },
    // Add more patterns here as needed
  ];

  let normalizedPath = pathname;
  patterns.forEach(({ pattern, replacement }) => {
    if (pattern.test(pathname)) {
      normalizedPath = replacement;
    }
  });

  return normalizedPath;
};

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const normalizedPath = normalizePathname(location.pathname);
    const pageName = normalizedPath.replace(/\//g, "").toUpperCase() || "HOME";
    
    // Track the page view with normalized path
    analytics.page({
      path: normalizedPath,
      search: location.search,
      hash: location.hash,
    });

  }, [location]);

  return null;
};

export default RouteChangeTracker;
